import React from 'react';
interface SectionEyebrowProps {
  text: string;
  className?: string;
}
export function SectionEyebrow({
  text,
  className = ''
}: SectionEyebrowProps) {
  return <span className={`block text-xs font-semibold uppercase tracking-widest text-terracotta mb-4 ${className}`} data-id="element-315">
      {text}
    </span>;
}